import React from 'react';
import { useTheme } from 'styled-components';

export const PipeSvg = (props) => {

  const { width, height, color } = props;

  const theme = useTheme();

  return (
    <svg width={width ?? "2"} height={height ?? "18"} viewBox="0 0 2 18" fill={color || theme?.colour?.primary || "#1DBD6B"} xmlns="http://www.w3.org/2000/svg">
      <rect x="0.692383" y="0.332031" width="1" height="16.9616" rx="0.5" />
    </svg>
  )
}